<template>
  <el-dialog
    :visible.sync="visible"
    :width="width"
    class="ann-table-dialog"
    :show-close="false"
    :close-on-click-modal="true"
  >
    <template #title>
      <div class="list-title">
        {{ title }}
        <i class="el-icon-close close-x" @click="$emit('update:visible', false)"></i>
      </div>
    </template>

    <el-table
      :data="rows"
      border
      style="width:100%;"
      row-class-name="clickable-row"
      @row-click="row => $emit('select', row)"
    >
      <el-table-column
        label="編號"
        type="index"
        width="80"
        align="center"
        :index="i => i + 1"
      />
      <el-table-column prop="date"  label="日期"      width="120" align="center"/>
      <el-table-column label="內容">
        <template slot-scope="{ row }">
          <div class="rich-content rich-clamp" v-html="safeHtml(row.title)"></div>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import DOMPurify from 'dompurify';

export default {
  name: 'AnnTableDialog',
  props: {
    /* v-model 規格：父層 :visible.sync */
    visible: { type: Boolean, required: true },
    title  : { type: String,  required: true },
    rows   : { type: Array,   required: true },
    width  : { type: String,  default : '820px' },
  },
  methods: {
    safeHtml(raw) {
      return DOMPurify.sanitize(raw || '', {
        ALLOWED_TAGS: ['p','br','strong','em','u','s','span'],
        ALLOWED_ATTR: ['style','class'],
      });
    },
  },
};
</script>

<style scoped>
.ann-table-dialog .el-dialog__header,
.ann-table-dialog .el-dialog__body {
  background: #dcdde1;
  padding: 10px;
}

/* 其餘樣式沿用你之前的 list-dialog */
.list-title{
  font-weight:700;font-size:18px;
  display:flex;justify-content:space-between;align-items:center
}
.close-x{font-size:22px;cursor:pointer;color:#333}
::v-deep .el-table th,::v-deep .el-table td{text-align:center}
.rich-content{line-height:1.6}
/* 與 Dashboard 卡片一致：只顯示前 2 行，點擊後再開詳細內容 */
.rich-clamp{
  overflow:hidden;
  display:-webkit-box;
  -webkit-box-orient:vertical;
  -webkit-line-clamp:2;
}
::v-deep .clickable-row{cursor:pointer}
.rich-content ::v-deep p{margin:0}
.rich-content ::v-deep .ql-align-center{text-align:center}
.rich-content ::v-deep .ql-align-right{text-align:right}
.rich-content ::v-deep .ql-align-justify{text-align:justify}
</style>
